// services/attributionIds.ts — ID atribusi persisten utk SEMUA pixel (Meta/Google/TikTok).
// Satu sumber kebenaran external_id + click ID browser:
// - external_id: UUID stabil per browser (localStorage cm_external_id) — dikirim via
//   identify (browser) & CAPI (server) supaya match + dedup antar channel.
// - ttclid: TikTok Click ID dari URL (?ttclid=) — disimpan 28 hari (jendela atribusi).
// - _ttp: cookie first-party TikTok pixel (dibaca utk CAPI field `ttp`).
const EXT_KEY = 'cm_external_id';
const TTCLID_KEY = 'cm_ttclid';
const TTCLID_TTL_MS = 28 * 86400000;

function safeGet(key: string): string | undefined {
  try {
    const v = localStorage.getItem(key);
    return v || undefined;
  } catch { return undefined; }
}
function safeSet(key: string, val: string): void {
  try { localStorage.setItem(key, val); } catch { /* abaikan */ }
}
function newUuid(): string {
  try {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  } catch { /* fallback di bawah */ }
  return `cm-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
}

// UUID stabil per browser — dibuat sekali, dipakai semua pixel + CAPI.
export function getPersistentExternalId(): string {
  const cur = safeGet(EXT_KEY);
  if (cur) return cur;
  const id = newUuid();
  safeSet(EXT_KEY, id);
  return id;
}

// Tangkap ?ttclid= dari URL (iklan TikTok) → persist 28 hari.
export function captureAttributionFromUrl(): void {
  try {
    const q = new URLSearchParams(window.location.search).get('ttclid');
    if (q?.trim()) safeSet(TTCLID_KEY, JSON.stringify({ v: q.trim(), t: Date.now() }));
  } catch { /* abaikan */ }
}

// ttclid tersimpan (masih dalam jendela 28 hari) — utk CAPI.
export function getStoredTtclid(): string | undefined {
  try {
    const raw = safeGet(TTCLID_KEY);
    if (!raw) return undefined;
    const o = JSON.parse(raw) as { v?: string; t?: number };
    if (!o?.v || !o?.t || Date.now() - o.t > TTCLID_TTL_MS) return undefined;
    return o.v;
  } catch { return undefined; }
}

// Nilai cookie _ttp (first-party TikTok) — utk CAPI field `ttp`.
export function getTtpCookie(): string | undefined {
  try {
    const m = document.cookie.match(/(?:^|;\s*)_ttp=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : undefined;
  } catch { return undefined; }
}
